// QR Code Generator site: text in → QR code out. Everything runs in the browser.

import encodeQR from "qr";

const MAX_BYTES = 2048;
const encoder = new TextEncoder();

const input = document.getElementById("input") as HTMLTextAreaElement;
const byteCountEl = document.getElementById("byteCount")!;
const qrOutput = document.getElementById("qrOutput")!;
const canvas = document.getElementById("qrCanvas") as HTMLCanvasElement;
const saveBtn = document.getElementById("saveBtn")!;

let debounceTimer: ReturnType<typeof setTimeout> | null = null;

function update(): void {
    const text = input.value;
    const byteLen = encoder.encode(text).length;

    byteCountEl.textContent = `${byteLen} / ${MAX_BYTES} B`;
    byteCountEl.classList.toggle("over", byteLen > MAX_BYTES);

    if (!text.trim() || byteLen > MAX_BYTES) {
        qrOutput.classList.add("hidden");
        return;
    }

    qrOutput.classList.remove("hidden");

    const modules = encodeQR(text, "raw", { ecc: "medium", border: 2 });
    const moduleCount = modules.length;
    const displaySize = Math.max(200, moduleCount * 4);
    const cellSize = Math.max(4, Math.floor(displaySize / moduleCount));
    const size = moduleCount * cellSize;

    canvas.width = size;
    canvas.height = size;
    canvas.style.width = `${displaySize}px`;
    canvas.style.height = `${displaySize}px`;

    const ctx = canvas.getContext("2d")!;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = "#000000";

    for (let row = 0; row < moduleCount; row++) {
        for (let col = 0; col < moduleCount; col++) {
            if (modules[row]![col]!) {
                ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
            }
        }
    }
}

function autoResize(): void {
    input.style.height = "auto";
    input.style.height = `${input.scrollHeight}px`;
}

input.addEventListener("input", () => {
    autoResize();
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(update, 150);
});

saveBtn.addEventListener("click", () => {
    const padding = 24;
    const exportCanvas = document.createElement("canvas");
    exportCanvas.width = canvas.width + padding * 2;
    exportCanvas.height = canvas.height + padding * 2;
    const ctx = exportCanvas.getContext("2d")!;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
    ctx.drawImage(canvas, padding, padding);
    const link = document.createElement("a");
    link.download = `${Date.now()}.png`;
    link.href = exportCanvas.toDataURL("image/png");
    link.click();
});

// --- Debug panel (shown when ?debug is in the URL) ---

const debugEl = document.getElementById("debug")!;

if (window.location.search.includes("debug")) {
    debugEl.hidden = false;
}

document.getElementById("debugToggle")!.addEventListener("click", () => {
    const panel = document.getElementById("debugPanel")!;
    panel.hidden = !panel.hidden;
});

document.getElementById("themeSelect")!.addEventListener("change", (e) => {
    const v = (e.target as HTMLSelectElement).value;
    document.documentElement.classList.remove("light", "dark");
    if (v === "light") document.documentElement.classList.add("light");
    if (v === "dark") document.documentElement.classList.add("dark");
});

// --- Prefill from URL param ---

const urlParams = new URLSearchParams(window.location.search);
const prefill = urlParams.get("text");
if (prefill) {
    input.value = prefill;
    autoResize();
    urlParams.delete("text");
    const clean = urlParams.toString();
    history.replaceState(null, "", window.location.pathname + (clean ? `?${clean}` : ""));
}

update();
